import { render } from "./FormRichText.vue?vue&type=template&id=3876e8b8"
import script from "./FormRichText.vue?vue&type=script&lang=js"
export * from "./FormRichText.vue?vue&type=script&lang=js"

import "./FormRichText.vue?vue&type=style&index=0&id=3876e8b8&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__